import axios from 'axios';
import {
  RECIPE_UPLOAD_REQUEST,
  RECIPE_UPLOAD_SUCCESS,
  RECIPE_UPLOAD_FAIL,
  RECIPE_EDIT_REQUEST,
  RECIPE_EDIT_SUCCESS,
  RECIPE_EDIT_FAIL,
  RECIPE_DELETE_REQUEST,
  RECIPE_DELETE_SUCCESS,
  RECIPE_DELETE_FAIL
} from '../reducerConsts/recipesConsts';
import { config } from '../../utils/axiosReqConfig';

const chefUploadRecipe = ({ recipeData, userId }) => async( dispatch ) => {
  dispatch({ type: RECIPE_UPLOAD_REQUEST });

  try{
    const response = await axios.post(
      `${process.env.REACT_APP_API_PATH}api/chefAdmin/recipes/uploadNew`,
      {
        data: recipeData,
        userId: userId
      },
      config
    );

    if(response.status === 200){
      dispatch({ type: RECIPE_UPLOAD_SUCCESS, payload: response?.data });
    };

  } catch(error) {
    dispatch({ type: RECIPE_UPLOAD_FAIL, payload: error.message });
  };  
};

const chefEditRecipe = ({ userId, recipeId, updatedRecipe }) => async( dispatch ) => {

  dispatch({ type: RECIPE_EDIT_REQUEST });

  try{
    const response = await axios.post(
      `${process.env.REACT_APP_API_PATH}api/chefAdmin/recipes/${recipeId}`,
      {
        updatedRecipe: updatedRecipe,
        userId: userId,
      },
      config
    );

    if(response.status === 200){
      dispatch({ type: RECIPE_EDIT_SUCCESS, payload: response?.data });
    };

  } catch(error) {
    dispatch({ type: RECIPE_EDIT_FAIL, payload: error.message });
  };  
};

const chefDeleteRecipe = ({ userId, recipeId }) => async( dispatch ) => {
  dispatch({ type: RECIPE_DELETE_REQUEST });

  try{
    const response = await axios.post(
      `${process.env.REACT_APP_API_PATH}api/chefAdmin/recipes/${recipeId}/delete`,
      { userId: userId },
      config
    );

    if(response.status === 200){
      dispatch({ type: RECIPE_DELETE_SUCCESS, payload: response?.data });
    };

  } catch(error) {
    dispatch({ type: RECIPE_DELETE_FAIL, payload: error.message });
  };  
};

export {
  chefUploadRecipe,
  chefEditRecipe,
  chefDeleteRecipe
}